import { render, staticRenderFns } from "./WhiteBoxCard.vue?vue&type=template&id=416f280e"
import script from "./WhiteBoxCard.vue?vue&type=script&lang=js"
export * from "./WhiteBoxCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports